import React, { Component } from 'react'
import ReactiveBase from '@appbaseio/reactivesearch/lib/components/basic/ReactiveBase';
import DataSearch from '@appbaseio/reactivesearch/lib/components/search/DataSearch';
import { withRouter } from "react-router-dom";
import './index.css';
const env = process.env.NODE_ENV || 'development';
const config = require('../config.json')[env];
import { encodeforspace } from '../utils/helper';

class Searchbar extends Component {

  constructor() {
    super();
  }

  getUrlParams = (url,name) => {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(url);
    if (results == null) {
      return null;
    }
    else {
      return decodeURI(results[1]) || 0;
    }
  }


  render() {
    return (
      <div className='cstm-search' style={{ marginRight: 10 }}>
        <ReactiveBase
          app="saasnew"
          type="doc"
          url={config.elastic_server} //http://localhost:9200  http://100.24.39.144:9200
        >
          <DataSearch
            componentId={"query"}
            dataField={["name"]}
            iconPosition="left"
            showClear={false}
            // autosuggest={true}
            // fieldWeights={[1, 3]}
            // highlight={true}
            // URLParams={true}
            // onKeyPress={this.handleKey}
            showIcon={true}
            icon={
              <span className='d-flex justify-content-start align-items-center'
                onClick={() => {
                  this.props.history.push({
                    pathname: '/',
                    search: '?query=' + document.getElementById('query-downshift-input').value
                  })
                }}
              >
                <i className='fa fa-search'></i>
              </span>
            }
            placeholder={"Search by company name..."}
            fuzziness={1}
            className='search '
            style={{ width: 300 }}
            defaultValue={this.getUrlParams(this.props.location.search,'query')}
            onValueSelected={
              (value, cause, source) => {
                if (cause == 'ENTER_PRESS') {
                  let queryParams = ''
                  if (value != '') {
                    queryParams = '?query=' + encodeURIComponent(value)
                  }
                  this.props.history.push({
                    pathname: '/',
                    search: queryParams
                  })
                } else if (cause == 'SUGGESTION_SELECT' && source) {
                  this.props.history.push(`/company/${encodeforspace(source.name)}`);
                }
              }
            }
          />
        </ReactiveBase>
      </div>
    )
  }

}

export default withRouter(Searchbar)


// WEBPACK FOOTER //
// ./client/src/components/searchbar.js